/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import  { useEffect, useState } from "react";
import { getErrorDetailsFn, getInputFieldProps, safeToString } from "../../../utils/common";
import useAPIHandler from "../../../hook/use-api-handler";
import { departmentValidationSchema } from "./department-validation";
import { DEPARTMENT_API, DEPARTMENT_INITIAL_STATE, DEPARTMENT_INPUT_FIELDS } from "./department-constant";
import fetchDataWithPromise from '../../../utils/fetch-data';
import useSnackbar from "../../../hook/use-snakbar";




const useDepartmentService = () => {
  const [esiInputs, setesiInputs] = useState(structuredClone(DEPARTMENT_INITIAL_STATE));
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [resource, setResource] = useState(null);

  useEffect(() => {
    // Refetch data whenever `page` or `search` changes
    setResource(fetchDataWithPromise(DEPARTMENT_API.DEPARTMENT_LIST.URL));
  }, [page, search]);
  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();
  const [holidayListinfo, setholidayListinfo] = useState({});
  const [open, setOpen] = useState(false);
  const [addAnother, setaddAnother] = useState(false);
  const handleClickOpen = () =>{
    setOpen(true);
    setErrors({})
  };
  const handleAddNewClickOpen = (data) =>{
    setesiInputs(data? data: structuredClone(DEPARTMENT_INITIAL_STATE));
    setErrors({});
    setOpen(true)};
  const handleClose = () => setOpen(false);

  const { fetchData } = useAPIHandler();
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const handleChangeFunction = (e, name) => {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    if (
      DEPARTMENT_INPUT_FIELDS[name].customOptions &&
      DEPARTMENT_INPUT_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = DEPARTMENT_INPUT_FIELDS[name].customOptions?.formatValueFn(
        value,
        esiInputs
      );
    }

    setesiInputs((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = departmentValidationSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
      //   context: { allowanceType: allowance.allowanceType },
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  };

  const handleSubmitFn = async () => {
    let URL,METHOD;
    if(esiInputs?.department_id){
      URL =DEPARTMENT_API.DEPARTMENT_UPDATE.URL+esiInputs?.department_id;
      METHOD = DEPARTMENT_API.DEPARTMENT_UPDATE.METHOD;
    }else{
      URL =DEPARTMENT_API.DEPARTMENT_CREATE.URL;
     METHOD = DEPARTMENT_API.DEPARTMENT_CREATE.METHOD;
    }
    

   

    const {
      deptName,
      status
    } = esiInputs;


    const payload = {
      data: {

        deptName,
        status
      },
      url: URL,
      method: METHOD,
    };



      
      const  {error} = departmentValidationSchema.validate(
        {
          deptName,
          status
        },
        {
          abortEarly: false,
        }
      );
     
  


    if ( error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
    } else {
      setCreateUpdateLoading(true);

      try {
        await fetchData(payload);
        setResource(fetchDataWithPromise(DEPARTMENT_API.DEPARTMENT_LIST.URL));


    



        openSnackbar({
          message:  `Department ${esiInputs?.department_id ? "Update": "Added"} succesfully!`,
          color: "success",
        });

     

     




        if(addAnother){
          setesiInputs(structuredClone(DEPARTMENT_INITIAL_STATE))
        }else{
          setOpen(false);
        }
      } catch (error) {
        setCreateUpdateLoading(false);
        const { message, errorObj } = getErrorDetailsFn(error);

        openSnackbar({
          message,
          color: "danger",
        });
        setErrors(errorObj);
      } finally {
        setCreateUpdateLoading(false);
      }
    }
  };

  function handleDisableAllESIFn() {
    if (!esiInputs.isDisableEsi) {
      setErrors({});
      setesiInputs({ ...structuredClone(DEPARTMENT_INITIAL_STATE), isDisableEsi: true });
    } else {
      setesiInputs((prev) => ({ ...prev, isDisableEsi: false }));
    }
  }

  const [stateList, setStateList] = useState([]);
  const getInputFieldPropsFn = (fieldName = "") => {
    const { customOptions = {}, ...restProps } =
      DEPARTMENT_INPUT_FIELDS[fieldName] || {};

    let disabled = !!restProps.disabled;
    if (esiInputs.isDisableEsi === true) {
      disabled = true;
    }

    const error = safeToString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: esiInputs,
        type: restProps.type||"text",
        error,
        handleChangeFunction,
      }),
      disabled,
    };

  
    return props;
  };


  useEffect(() => {


    const URL = DEPARTMENT_API.DEPARTMENT_LIST.URL;
    const METHOD = DEPARTMENT_API.DEPARTMENT_LIST.METHOD;
    const payload={
      url:URL,
      METHOD
    }
    fetchData(payload).then(
      (res) => {




      

        setholidayListinfo(res?.data||{});
        }
    );
   
  }, []);

  function hanldeAddAnotherFn(){
     setaddAnother(prev=>!prev)
  }

  return {
    esiInputs,
    setesiInputs, getInputFieldPropsFn,
    handleDisableAllESIFn,
    handleSubmitFn,
    createUpdateLoading,
    stateList,
    open, setOpen
    , handleClickOpen 
    , handleClose,
    addAnother, setaddAnother,
    hanldeAddAnotherFn,
    holidayListinfo,
    handleAddNewClickOpen,
    resource,
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  };
};

export default useDepartmentService;
